import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";


import n_img from "../partners/tools/soyuz.jpg";
import ScienceSelectTool from "../partners/tools/ScinceSelectTool";
import LabsPage from "./labs-page";
import LabsSearchPage from "./labs-search-page";

const ScienceLabsPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    const [bigUrl, setBigUrl] = useState(undefined);

    return (
        <OuterWrapper className={"about_page"}>
            <TopAb2
                className={""}
            >
                {/*{*/}
                {/*    isRu ? "Научно-популярный туризм" : "Science tourism"*/}
                {/*}*/}
            </TopAb2>

            <Wrapper>

                <TopPlaceholder>
                    {/*<SupTopPlaceholder>*/}
                    {/*    <BackLink href={"/"}></BackLink>*/}
                    {/*</SupTopPlaceholder>*/}
                    <Heading>
                        {isRu ? 'Наука в университетах' : 'Science in Universities'}
                    </Heading>
                </TopPlaceholder>

                <LabsSearchPage />

            </Wrapper>


            {/*<Wrapper>*/}
            {/*    /!*<TopImg src={n_img} />*!/*/}

            {/*    <TopPlaceholder>*/}
            {/*        /!*<SupTopPlaceholder>*!/*/}
            {/*        /!*    <BackLink href={"/"}></BackLink>*!/*/}
            {/*        /!*</SupTopPlaceholder>*!/*/}
            {/*        <Heading>*/}
            {/*            Наука*/}
            {/*        </Heading>*/}

            {/*        <p>*/}

            {/*        </p>*/}

            {/*    </TopPlaceholder>*/}

            {/*    <ScienceSelectTool*/}

            {/*    />*/}


            {/*</Wrapper>*/}

        </OuterWrapper>
    );
};

export const TopAb2 = styled.div`
  height: calc(max(50vh, 500px));
  //height: calc(max(30vh, 300px));
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  background-image: url("${n_img}");
  margin-top: -30px;
  color: white;
  //font-size: 88px;
  font-size: 50px;
  line-height: 120px;
  font-family: "Noto Sans", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  
  @media (max-width: 900px) {
    font-size: 28px;
    text-align: center;
    line-height: 34px;
    height: 20vh;
  }
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default ScienceLabsPage;
